import type { RefObject } from "react"
import { useEffect } from "react"

import { enhanceDocsTabs } from "@productlane/lib/src/docs-tabs"
import { highlightCodeBlocksIn } from "@productlane/lib/src/highlight-code"

// The review diff renders article HTML directly, so the tab bar and the
// highlighting the portal builds in its own hook have to run here too.
export function useDocsPanels(
	containerRef: RefObject<HTMLElement | null>,
	contentKey: unknown,
) {
	useEffect(() => {
		const container = containerRef.current
		if (!container) return

		const cleanup = enhanceDocsTabs(container)
		highlightCodeBlocksIn(container)

		return cleanup
	}, [containerRef, contentKey])
}
